export default "__VITE_ASSET__vF$io0Yq__"